import { render, staticRenderFns } from "./AMovimientos.vue?vue&type=template&id=1d8bd92d"
import script from "./AMovimientos.vue?vue&type=script&lang=js"
export * from "./AMovimientos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports